import { disconnectGameSocket } from 'lib/socket';
import { reconcileSessionAfterUnload } from 'lib/api';

/** App boot: clear legacy unload flags and reset socket for a fresh connection. */
export function initSessionUnloadHandling(): void {
  reconcileSessionAfterUnload();
  disconnectGameSocket();
}

/**
 * Game session tokens are not revoked on tab close or in-app navigation.
 * Kept as a no-op so existing page imports stay stable.
 */
export function useExpireSessionOnTabClose(_enabled = true): void {
  /* intentionally empty */
}
